module.exports = __webpack_public_path__ + "img/Bottom.664730a0.png";